import { Button } from '@ads/components-react';
import { eventDashboardQueries } from '@linka/http/event-dashboard';
import { useTranslation } from '@linka/i18n';
import { useQuery } from '@tanstack/react-query';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { DialogClose, DialogContent, DialogDescription, DialogTitle } from '../../../../dialog/dialog';
import { toast } from '../../../../toast/toast';
import { useExportContext } from './context';
import { exportDataAtom } from './state';

interface ExportInProgressDialogProps {
  exportId: string;
}

export const ExportInProgressDialog = ({ exportId }: ExportInProgressDialogProps) => {
  const t = useTranslation();
  const { eventId, assets } = useExportContext();
  const setExportData = useSetAtom(exportDataAtom);
  const { data } = useQuery(eventDashboardQueries.downloadStatus(eventId, exportId));

  useEffect(() => {
    if (!data) return;

    if (data.exportId && data.status) {
      setExportData({ exportId: data.exportId, status: data.status });
    }

    if (data.status === 'FAILED' && data.message) {
      setExportData(null);
      toast({ title: t('export-flow.error'), description: data.message, status: 'danger' });
    }
  }, [data]);

  return (
    <DialogContent className='!max-w-[25.25rem] flex flex-col items-center justify-center gap-xxs'>
      <img
        fetchPriority='high'
        src={assets?.spinner ?? '/svg/spinner.svg'}
        alt={t('export-flow.loading')}
        className='size-md animate-spin'
      />
      <div className='text-center space-y-micro'>
        <DialogTitle className='[&>button]:hidden justify-center ts-subtitle-sm text-ctx-content-title'>
          {t('export-flow.dialog.status.title')}
        </DialogTitle>
        <DialogDescription className='text-ctx-content-base ts-paragraph-xxs line-clamp-none'>
          {t('export-flow.dialog.status.description')}
        </DialogDescription>
        <DialogClose asChild>
          <Button hierarchy='secondary' size='md'>
            {t('export-flow.cancel')}
          </Button>
        </DialogClose>
      </div>
    </DialogContent>
  );
};
